import { render, staticRenderFns } from "./SAudioUploadPreview.vue?vue&type=template&id=1c538c88&"
import script from "./SAudioUploadPreview.vue?vue&type=script&lang=js&"
export * from "./SAudioUploadPreview.vue?vue&type=script&lang=js&"
import style0 from "./SAudioUploadPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports